export enum StorageDestination {
  // Values match those in Server/API
  NewHealthRecordTemporaryStorage = "NewHealthRecordTemp",
  HealthRecordDocuments = "HealthRecordDocuments",
  ClinicDocuments = "ClinicDocuments",
  LegalGuardianSupportingDocuments = "LegalGuardianSupportingDocuments",
  MedicalRecordReleaseSupportingDocuments = "MedicalRecordReleaseSupportingDocuments",
}
